import { useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { CatalogApi, catalogApiRef } from '@backstage/plugin-catalog-react';


interface ProjectOption {
  value: string;
  label: string;
}

const useProjectPicker: (systemRef: string) => {
  options: ProjectOption[];
} = (systemRef: string) => {

  const catalogApi: CatalogApi = useApi(catalogApiRef);
  const [options, setOptions] = useState<ProjectOption[]>([]);

  useEffect(() => {
    async function fetchGroups() {
      if (!systemRef) {
        setOptions([]);
        return;
      }

      try {
        const system = await catalogApi.getEntityByRef(systemRef);
        if (!system) {
          setOptions([]);
          return;
        }

        const projects = await catalogApi.getEntities({
          filter: {
            kind: 'Component',
            'spec.system': system.metadata.name,
          },
        });
        
        const filteredProjects = projects.items.filter(item => {
          const specKeys = Object.keys(item.spec ?? {});
          return !specKeys.some(key => key.toLowerCase() === 'subcomponentof');
        });

        const projectOptions: ProjectOption[] = filteredProjects.map(
          item => ({
            value: item.metadata.name,
            label: item.metadata.name,
          }),
        );

        setOptions(projectOptions);
      } catch (error) {
        setOptions([]);
      }
    }

    fetchGroups();
  }, [catalogApi, systemRef]);

  return { options };

}

export default useProjectPicker;